/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openinghours1Inputs */

const en_openinghours1 = /** @type {(inputs: Openinghours1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening Hours`)
};

const de_openinghours1 = /** @type {(inputs: Openinghours1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnungszeiten`)
};

/**
* | output |
* | --- |
* | "Opening Hours" |
*
* @param {Openinghours1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const openinghours1 = /** @type {((inputs?: Openinghours1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openinghours1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openinghours1(inputs)
	return de_openinghours1(inputs)
});
export { openinghours1 as "openingHours" }